import {
    ICompanySyncstep,
    IExportAttribute,
    IMessageData,
    IObjectType,
    IRouteDefinitionParams,
    IRuleset
} from "../../../index";
import * as ko from "knockout";
import {IExportFlowMutable} from "../index";
import {ObjectTypeId} from "../../../constants";
import {nsExportTemplate} from "../fn";
import {_} from 'lodash';
import {KOSubscriptionTracker} from "../../../util/KOSubscriptionTracker";
import {nsRoute} from "../../../util/route";
import {nsSync} from "../../../util/nsSync";
import {Mutable} from "../mutable";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import ParsedRouteDataDecorator = nsRoute.ParsedRouteDataDecorator;
import {IRequestObject} from "../../../req/index";
import mutableHtml from './mutable.html?raw';

export let template: string = mutableHtml;

interface IParams extends IRouteDefinitionParams {
    exportflow: KnockoutObservableArray<IExportFlowMutable>
    objecttype: KnockoutObservable<IObjectType>
    syncstep: KnockoutObservable<ICompanySyncstep>
    mutable: Mutable
}

export class viewModel extends ParsedRouteDataDecorator {
    private ObjectTypeId = ObjectTypeId;
    isUsername: KnockoutObservable<boolean> = ko.observable(false);
    isEmail: KnockoutObservable<boolean> = ko.observable(false);
    isInitials: KnockoutObservable<boolean> = ko.observable(false);

    data: { [key: string]: Obs } = {};
    objecttype: KnockoutObservable<IObjectType>;
    syncstep: KnockoutObservable<ICompanySyncstep>;

    messageData: KnockoutObservable<IMessageData | null> = ko.observable(null);
    isReady: KnockoutObservable<boolean> = ko.observable(false);

    private kosub: KOSubscriptionTracker = new KOSubscriptionTracker();
    private _exportflow: KnockoutObservableArray<IExportFlowMutable>;
    static EXPORT_ATTRIBUTES: IExportAttribute[];
    private readonly mutable: Mutable;
    private reqobj_getexportattributes!: IRequestObject<IExportAttribute[]>;

    constructor(params: IParams) {
        super(params);
        this._exportflow = params.exportflow;
        this.objecttype = params.objecttype;
        this.syncstep = params.syncstep;
        this.mutable = params.mutable;

        this.kosub.subscribe(this.isUsername, this.updateExportFlows.bind(this));
        this.kosub.subscribe(this.isEmail, this.updateExportFlows.bind(this));
        this.kosub.subscribe(this.isInitials, this.updateExportFlows.bind(this));

        // Create keeps this panel mounted before objecttype/syncstep are chosen — wait for both.
        const onObjectTypeOrSyncstepChange = () => this.request();
        this.kosub.subscribe(this.objecttype, onObjectTypeOrSyncstepChange);
        this.kosub.subscribe(this.syncstep, onObjectTypeOrSyncstepChange);
        this.request();
    }

    private updateExportFlows() {
        this.data['vismauserid']?.addOrRemove(this.isUsername() || this.isEmail() || this.isInitials());
        this.data['vismaalias']?.addOrRemove(this.isUsername());
        this.data['vismaemailtype']?.addOrRemove(this.isEmail());
        this.data['vismaemail']?.addOrRemove(this.isEmail());
        this.data['vismainitials']?.addOrRemove(this.isInitials());
    }

    private request() {
        const objecttype = this.objecttype();
        const syncstep = this.syncstep();
        if (!objecttype || !syncstep) {
            this.isReady(false);
            return;
        }

        // keepPanelAlive mounts this panel on every edit; only on-prem AD export should get Visma companion mappings.
        if (!nsSync.isSyncstepOnPremAD(syncstep.syncstep.id)) {
            this.reqobj_getexportattributes?.promise.abort();
            this.isReady(false);
            return;
        }

        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});
        this.reqobj_getexportattributes?.promise.abort()
        this.reqobj_getexportattributes = nsExportTemplate.getExportAttributes(syncstep.syncstep.id, objecttype.id);
        this.reqobj_getexportattributes.request
            .then((data: IExportAttribute[]) => {
                viewModel.EXPORT_ATTRIBUTES = data;

                this.data['vismauserid'] = new Obs("vismauserid", this._exportflow);
                this.data['vismaalias'] = new Obs("vismaalias", this._exportflow);
                this.data['vismaemailtype'] = new Obs("vismaemailtype", this._exportflow);
                this.data['vismaemail'] = new Obs("vismaemail", this._exportflow);
                this.data['vismainitials'] = new Obs("vismainitials", this._exportflow);

                const isUsername = !!this.data['vismaalias'].val();
                this.isUsername(isUsername);

                const isEmail = !!this.data['vismaemailtype'].val() || !!this.data['vismaemail'].val();
                this.isEmail(isEmail);

                const isInitials = !!this.data['vismainitials'].val();
                this.isInitials(isInitials);

                this.data['vismauserid'].setDefault("[webuserid]");
                this.data['vismaalias'].setDefault("[username]");
                this.data['vismaemailtype'].setDefault("WORK");
                this.data['vismaemail'].setDefault("[email]");
                this.data['vismainitials'].setDefault("[username]");

                this.messageData(null);
                this.isReady(true);
            });
    }

    override dispose() {
        this.kosub.unsuscribeAll();
        _.forEach(this.data, (obs: Obs) => obs.dispose());
        this.reqobj_getexportattributes?.promise.abort()
    }

}

class Obs {

    val: KnockoutObservable<string>;
    ruleset: KnockoutObservable<IRuleset | null>;
    protected efm: IExportFlowMutable;

    constructor(targetattribute: string, protected _data: KnockoutObservableArray<IExportFlowMutable>) {
        this.efm = this.getExportFlowMutable(targetattribute);
        this.val = this.efm.expression;
        this.ruleset = this.efm.ruleset;
    }

    addOrRemove(bool: boolean) {
        if (bool) {
            const exists = this._data().indexOf(this.efm) > -1;
            if (!exists) {
                this._data.push(this.efm);
            }
        } else {
            this._data.remove(this.efm);
        }
    }


    private getExportFlowMutable(targetattribute: string): IExportFlowMutable {
        // find an existing mutable item
        let efm = this._data().find((item: IExportFlowMutable) => item.targetattribute() && item.targetattribute().name == targetattribute);
        if (!efm) {
            // ...or create a new one
            efm = nsExportTemplate.createExportFlowMutable();
            efm.targetattribute(viewModel.EXPORT_ATTRIBUTES.find((item: IExportAttribute) => item.name == targetattribute));
        }
        // and return it
        return efm;
    };

    setDefault(val: string) {
        if (!this.val()) {
            this.val(val);
        }
    }

    dispose() {
    }

}
